module.exports = __webpack_public_path__ + "img/半枝莲.a3ee53e4.jpg";